import {
  SearchParams,
  encodeSearchParams,
} from '@elemental/pagination-helpers';
import { faker } from '@faker-js/faker';

import { DataLoadProps } from '../types/pagination';
import routeToDataLoad from './route-to-data-load';

const column1 = faker.string.uuid();
const column2 = faker.string.uuid();

const initialParams: DataLoadProps = {
  paginationModel: {
    page: 0,
    pageSize: 100,
  },
  sortModel: [
    {
      field: 'createdAt',
      sort: 'desc',
    },
  ],
};

const mockSearchParams: SearchParams<Record<string, string>> = {
  filters: [
    {
      column: column1,
      op: 'eq',
      value: faker.date.anytime().toISOString(),
    },
  ],
  page: faker.number.int(),
  per_page: faker.number.int(),
  projection: [column2, column1],
  sort_by: [
    {
      column: column2,
      sort_ascending: faker.datatype.boolean(),
    },
  ],
};

describe('route to data load', () => {
  test('test with only initial params', () => {
    expect(routeToDataLoad(initialParams)).toStrictEqual(initialParams);
  });

  test('test with mocked search params', () => {
    const encodedParams = encodeSearchParams(mockSearchParams);
    const dataLoadParams = new URLSearchParams(
      encodedParams as Record<string, string>,
    );
    const searchString = `?dataLoad=${encodeURIComponent(dataLoadParams.toString())}`;
    const originalLocation = globalThis.location;

    // @ts-expect-error - JSDOM requires delete before reassignment
    delete globalThis.location;
    globalThis.location = {
      ...originalLocation,
      search: searchString,
    } as Location;

    expect(routeToDataLoad(initialParams)).toStrictEqual({
      paginationModel: {
        page: mockSearchParams.page,
        pageSize: mockSearchParams.per_page,
      },
      sortModel: [
        {
          field: mockSearchParams.sort_by?.[0].column,
          sort: mockSearchParams.sort_by?.[0].sort_ascending ? 'asc' : 'desc',
        },
      ],
    });
  });
});
